import { Image, View } from 'react-native';
import { StyleSheet } from 'react-native';

export function GiftCardImage() {
  return (
    <View style={styles.imageContainer}>
      <Image source={require('./default-card-image.png')} style={styles.image} />
    </View>
  );
}

const styles = StyleSheet.create({
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    aspectRatio: 1.9,
    maxHeight: 264,
  },
  image: {
    width: '100%',
    height: '100%',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
});
